import TokenArtifact from "../contracts/BubonicBastards.json";
import contractAddress from "../contracts/contract-address.json";
import music from "../resources/audio/bubos.flac";
import headerIcon from "../resources/images/BUBO/Bubonic_Bastards.png";

import MARKETPLACE_LOGO from "../resources/logos/paintswap.svg";
export const NFT_MARKETPLACE_URL = "https://paintswap.finance/marketplace/";

// import MARKETPLACE_LOGO from "../resources/logos/nftkey.svg";
// export const NFT_MARKETPLACE_URL = "https://nftkey.app/ftm";

import CRYPTO_CURRENCY_SYMBOL from "../resources/logos/ftm-logo.svg";

export const CRYPTO_CURRENCY_NAME = "Fantom";
export const CRYPTO_CURRENCY_TICKER = "FTM";

export const NETWORK_NAME = "Fantom Opera";
export const NETWORK_ID = '250';

export const TAGLINE = "Bubonic Bastards";
export const SUBTEXT = "Join the fight against the plague";
export const MINT_FORM_TITLE = "Fight the Plague...";

export const MINT_QUANTITY_MIN = 1;
export const MINT_QUANTITY_MAX = 20;

const MINT_START_NICKNAME = "Mint";
const MINT_END_NICKNAME = "Mint";

export function getMintCountDownMessage(isMintLive: boolean, startTime: Date | undefined, endTime: Date | undefined): string {
  if(startTime !== undefined && !isMintLive && startTime > new Date() ) {
    // mint not live, start later than now
    return `${MINT_START_NICKNAME} starts in`;
  } else if (endTime !== undefined && !isMintLive && endTime < new Date() ) {
    // mint not live, end earlier than now
    return "Minting is over";
  } else {
    return `${MINT_END_NICKNAME} happens in:`; 
  }
}

export { 
  CRYPTO_CURRENCY_SYMBOL,
  music,
  headerIcon,
  MARKETPLACE_LOGO,
  TokenArtifact,
  contractAddress
};

/* --------- PERMANENT CONSTANTS  --------- */
export const ERROR_CODE_TX_REJECTED_BY_USER = 4001;

export const MINT_IN_PROGRESS = "Mint In Progress";

export const MINT_BUTTON_NOT_LIVE_MESSAGE = "Mint not live";
export const MINT_BUTTON_SOLD_OUT_MESSAGE = "The mint has sold out!";
export const MINT_BUTTON_PROCEED_MESSAGE = "Click to mint";
export const MINT_BUTTON_NO_WALLET_MESSAGE = "Oy! Connect yer wallet to mint...";

export const MINT_FAILED_MESSAGE = "Mint claim failed";
export const MINT_SUCCESS_MESSAGE = "Mint claim success";

export const METAMASK_MISSING_MESSAGE = "You gotta install Metamask first ";

export const MINT_QUANTITY_HELPER_MESSAGE = `Enter a number between ${MINT_QUANTITY_MIN}-${MINT_QUANTITY_MAX}`;

export const COUNTDOWN_COMPLETE_MESSAGE = "Times up!";
